function Separator() {
  return (
    <div className="w-full h-[1px] bg-gray-300"></div>
  );
}

export default Separator;